module.exports = __webpack_public_path__ + "static/img/15894750706400.6995838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15894750706400.png
// module id = gk1t
// module chunks = 3